module.exports = __webpack_public_path__ + "static/media/Mask.71b6a4d7.svg";